<template>
<!-- Main Start -->
	 <section class="hot-picks-section">
      <div class="container">
        <h2 class="section-title">Top Intro's</h2>
        <VueSlickCarousel v-bind="settings" >
          <div  v-for="item in 5" :key="item._id">
      <router-link :to="{ path: '/offer-detail/'+ features1[item].id}">
            <div class="Card">
              <img :src="features1[item].image" class="img-fluid" alt="" />
              <div class="Card_info">
                <h6 class="card-title">{{ features1[item].title }}</h6>
                <h6 class="card-info">{{ features1[item].title }}</h6>
              </div>
            </div>
      </router-link>
        </div>
     
    </VueSlickCarousel>
      </div>
    </section>
   <!-- Main End -->
</template>

<script>

import { db } from '../../main'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css' 
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'  
export default {
  components:{
    'VueSlickCarousel':VueSlickCarousel
},
data(){
    return{
        features1: [],
		size:'',
        components:{},
	    settings: {
                    "responsive": [
					{
					  "settings": {
                                   "slidesToShow": 3,
								"slidesToScroll": 3,
								"infinite": false,
								"dots": true
                            }
					},
					{
                            "breakpoint": 3000,
                            "settings": {
                                  "slidesToShow": 3,
								"slidesToScroll": 3,
								"infinite": false,
								"dots": true
                            }
                        },
                        {
                            "breakpoint": 1024,
                            "settings": {
                               "slidesToShow": 3,
								"slidesToScroll": 3,
								"infinite": false,
								"dots": true
                            }
                        },
                        {
                            "breakpoint": 767,
                            "settings": {
                                   "slidesToShow": 1,
								"slidesToScroll": 1,
								"infinite": false,
								"dots": true
                            }
                        }
                    ]
                }
    }    
  },

  created: function()
  {
      this.fetchFeatures();
  },

  methods: {
    
      fetchFeatures()
    {
          window.scrollTo({ top: 0, behavior: 'smooth' }); 
       db.collection("offers")
      .get()
      .then((querySnapshot) => {
       
        querySnapshot.forEach((doc) => {
             if(doc.data().blogshowoption == 1){
			     //this.size =  doc.data().size;
              this.features1.push({
                id: doc.id,
                title: doc.data().title,
                image: doc.data().image,
                created: doc.data().created,
              }); 
             }
         // });
          

        });
      })
      .catch((error) => {
        console.log("Error getting documents: ", error);
      });
     
	   

    }
  }
}
    
</script>
<style>
.slick-dots li button:before {
    font-size: 15px;
    color: #03e1bc;
}
.slick-dots li.slick-active button:before{
	color: #03e1bc;
}

.hot-picks-section .slick-next::before {
    color: #03e1bc;
}
.hot-picks-section .slick-prev::before {
    color: #03e1bc;
}
.hot-picks-section .slick-prev.slick-disabled:before, .hot-picks-section .slick-next.slick-disabled:before {
    opacity: 0.5;
}

@media (max-width:1024px){
.hot-picks-section .slick-next {
    right: -14px;
}
.hot-picks-section .slick-prev {
    left: -14px;
}
}
</style>
